// apps/roleforge-app/src/components/audit/ExportAssetsLink.tsx
//
// Plan 3e-ii Task 5.6 — secondary "Download my Blueprint Bundle" CTA on the
// Activation Moment screen (RoleForge v2 Plan 2 Task 5 promoted it from a
// subtle text link to the spec's dual-CTA completion moment). Streams the
// audit export bundle (zip) and triggers a browser download.
//
// The download sequence, failure copy (`describeExportFailure`, issue
// #1326 (4)), and busy/error state now live in lib/bundle-download.ts,
// shared with the delivery page (AuditDashboardPage) — this component is
// just the Activation Moment presentation of it.

import { useBundleDownload } from '../../lib/bundle-download';

export function ExportAssetsLink({ auditId }: { auditId: string }) {
  const { busy, error, download } = useBundleDownload(auditId);

  return (
    <div className="flex flex-col items-center gap-1">
      <button
        type="button"
        onClick={download}
        disabled={busy}
        className="inline-flex items-center justify-center rounded-lg border border-slate-300 px-6 py-3 text-sm font-semibold text-slate-900 hover:bg-slate-100 dark:border-slate-600 dark:text-slate-100 dark:hover:bg-slate-800 disabled:opacity-50"
        data-testid="export-assets-link"
      >
        {busy ? 'Preparing…' : error?.retryable ? 'Try the download again' : 'Download my Blueprint Bundle'}
      </button>
      {error && (
        <p
          role="status"
          aria-live="polite"
          data-testid="export-assets-error"
          className="text-xs text-ember"
        >
          {error.message}
        </p>
      )}
    </div>
  );
}
